module.exports = __webpack_public_path__ + "img/2-min.4189d001.jpg";